import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderChatBoat from "./HeaderChatBoat";

const COUNTRIES = [
  { id: 1, name: "Malawi" },
  { id: 2, name: "Zambia" },
];

const SAMPLE_PROMPTS = [
  "What is the pond temperature in this camp?",
  "What is the air temperature in this camp?",
  "What is the advisory for next week for this camp?",
];

function ChatBoatHome() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [countryId, setCountryId] = useState("");
  const [adm2Id, setAdm2Id] = useState(null);
  const [adm3Id, setAdm3Id] = useState(null);
  const [question, setQuestion] = useState("");

  const handleStep1Continue = (e) => {
    e.preventDefault();
    if (!countryId) return;
    setStep(2);
  };

  const handleStep2Continue = (e) => {
    e.preventDefault();
    navigate("/chat", {
      state: {
        country_id: parseInt(countryId),
        adm2_id: adm2Id,
        adm3_id: adm3Id,
        initialQuestion: question,
      },
    });
  };

  return (
    <>
      <HeaderChatBoat />
      <section className="content-height p-5 pt-4 d-flex justify-content-center align-items-center">
        <div className="container-fluid text-center">
          <div className="row justify-content-center">
            <div className="historyText">
              <p className="mb-0">
                <img src="/assets/images/Clock.png" height={15} alt="Logo" /> History
              </p>
            </div>

            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
              <div className="chatBoatBox mx-auto px-4 mt-5">

                {/* Step 1: Country + District */}
                {step === 1 && (
                  <>
                    <p className="mb-0 pt-1">
                      <img src="/assets/images/logo-chatboat.png" alt="Logo" className="img-fluid mb-2" />
                    </p>
                    <h2>Welcome to Blue Resilience / Ulimi Wansomba</h2>
                    <p>Enter data below to get started</p>

                    <form className="formBox mt-4" onSubmit={handleStep1Continue}>
                      <div className="form-group text-start">
                        <label>
                          Select Country <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select mt-1 h42px"
                          value={countryId}
                          onChange={(e) => setCountryId(e.target.value)}
                          required
                        >
                          <option value="">Select Country</option>
                          {COUNTRIES.map((c) => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group text-start">
                        <label>District</label> <br />
                        {[1, 2, 3, 4, 5, 6].map((num) => (
                          <button
                            key={num}
                            type="button"
                            className={`btn custom-btn ${adm2Id === num ? "active" : ""}`}
                            onClick={() => setAdm2Id(num)}
                          >
                            District {num}
                          </button>
                        ))}
                      </div>

                      <button
                        type="submit"
                        className="btn btn-chatBoatLogin mt-4 w-100"
                        disabled={!countryId}
                      >
                        Continue
                      </button>
                    </form>
                  </>
                )}

                {/* Step 2: Camp + Prompt */}
                {step === 2 && (
                  <>
                    <p className="mb-0 pt-1">
                      <img src="/assets/images/logo-chatboat.png" alt="Logo" className="img-fluid mb-2" />
                    </p>
                    <h2>Welcome to Blue Resilience / Ulimi Wansomba</h2>
                    <p>Enter data below to get started</p>

                    <form className="formBox mt-4" onSubmit={handleStep2Continue}>
                      <div className="form-group text-start">
                        <label>Camp</label> <br />
                        {[1, 2, 3, 4, 5, 6].map((num) => (
                          <button
                            key={num}
                            type="button"
                            className={`btn custom-btn ${adm3Id === num ? "active" : ""}`}
                            onClick={() => setAdm3Id(num)}
                          >
                            Camp {num}
                          </button>
                        ))}
                      </div>

                      <div className="form-group text-start">
                        <label>Select a sample prompt</label> <br />
                        {SAMPLE_PROMPTS.map((prompt, i) => (
                          <button
                            key={i}
                            type="button"
                            className={`btn btn-Quetion mt-1 ${question === prompt ? "active" : ""}`}
                            onClick={() => setQuestion(prompt)}
                          >
                            {prompt}
                          </button>
                        ))}
                      </div>

                      <button type="submit" className="btn btn-chatBoatLogin mt-4 w-100">
                        Start Chat
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChatBoatHome;
